/**
 * Clone Utilities
 * Provides optimized deep cloning functions for objects and arrays
 */

/**
 * Deep clones an object or array using the most efficient method available
 * Uses structuredClone (native browser API) when available for better performance,
 * falls back to JSON serialization for compatibility
 *
 * @param {*} data - The data to clone (object, array, or primitive)
 * @returns {*} Deep cloned copy of the input data
 *
 * @example
 * const original = { a: 1, b: { c: 2 } };
 * const cloned = deepClone(original);
 * cloned.b.c = 3; // original.b.c remains 2
 */
export const deepClone = (data) => {
  // Use native structuredClone if available (modern browsers)
  // This is faster and handles more data types than JSON methods
  if (typeof structuredClone !== "undefined") {
    try {
      return structuredClone(data);
    } catch (error) {
      console.error("Error in deepClone:", error);
    }
  }
  const cloned = JSON.parse(JSON.stringify(data));
  return cloned;
};
